import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "mb-0",
  style: {"font-weight":"bold"}
}
const _hoisted_4 = {
  class: "header mb-2",
  style: {"position":"sticky","top":"0","background":"white","z-index":"1000","padding":"1rem 0"}
}
const _hoisted_5 = { style: {"display":"flex","gap":"8px","align-items":"center"} }
const _hoisted_6 = {
  key: 0,
  href: "/Multi-ComponentTemplateUpload-v3.xlsx",
  download: "",
  class: "btn btn-sm btn-primary mt-0",
  style: {"width":"12rem","border-radius":"3px","padding":"4px","display":"inline","text-align":"center","background-color":"#0054a6","color":"white","text-decoration":"none"}
}
const _hoisted_7 = { class: "dropdown-wrapper" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 mb-4" }
const _hoisted_10 = {
  class: "card",
  style: {"border-radius":"10px"}
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_StyleCreateComp = _resolveComponent("StyleCreateComp")!
  const _component_EditStyle = _resolveComponent("EditStyle")!
  const _component_StyleGrid = _resolveComponent("StyleGrid")!
  const _component_DialogBox = _resolveComponent("DialogBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_GridLoading, { style: {"position":"relative","z-index":"999999","top":"19rem"} })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.visible)
            ? (_openBlock(), _createBlock(_component_StyleCreateComp, {
                key: 0,
                visible: _ctx.visible,
                onUpdate: _ctx.update
              }, null, 8, ["visible", "onUpdate"]))
            : _createCommentVNode("", true),
          (_ctx.visibleEdit)
            ? (_openBlock(), _createBlock(_component_EditStyle, {
                key: 1,
                visibleEdit: _ctx.visibleEdit,
                onUpdate: _ctx.update,
                editStyleId: _ctx.editStyleId,
                duplicateEditId: _ctx.duplicateEditId
              }, null, 8, ["visibleEdit", "onUpdate", "editStyleId", "duplicateEditId"]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "file",
            ref: "fileToUpload",
            class: "d-none",
            id: "fileUpload",
            "aria-label": "Upload File",
            accept: ".xls,.xlsx",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
          }, null, 544),
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.styles")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.tenantSettingsLoaded && !_ctx.isV4CalculationEngine)
                ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", {
                      class: "fa fa-download",
                      style: {"font-size":"large","margin-right":"7px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("appSideBar.downloadTemplate")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tenantSettingsLoaded && !_ctx.isV4CalculationEngine)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-sm btn-primary mt-0",
                    style: {"width":"12rem","border-radius":"3px","padding":"4px","display":"inline","text-align":"center","background-color":"#0054a6","color":"white"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args)))
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", {
                      class: "fa fa-upload",
                      style: {"font-size":"large","margin-right":"7px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.uploadANewStyle")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedReportPrintingOption) = $event)),
                class: "dropdown-left mt-0",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDropdownChange && _ctx.handleDropdownChange(...args))),
                style: {"width":"6rem","border-radius":"3px","padding":"4px","display":"inline","text-align":"center","margin-right":"10px"},
                "aria-label": "Report Printing Option"
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("option", {
                  value: "pdf",
                  style: {"text-align":"left","padding-left":"0"}
                }, "PDF", -1),
                _createElementVNode("option", {
                  value: "csv",
                  style: {"text-align":"left","padding-left":"0"}
                }, "CSV", -1)
              ]))], 544), [
                [_vModelSelect, _ctx.selectedReportPrintingOption]
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary mt-0",
                style: {"width":"9rem","border-radius":"3px","padding":"4px","display":"inline","text-align":"center","background-color":"#0054a6","color":"white"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addStyleButton && _ctx.addStyleButton(...args)))
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("span", {
                  class: "fa fa-plus",
                  style: {"font-size":"large","margin-right":"7px"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.buttonText), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_StyleGrid, {
                      ref: "detailsGrid",
                      stylesData: _ctx.stylesData,
                      totalStylesCount: _ctx.totalStylesCount,
                      onChangeDataHandler: _ctx.changeDataHandler,
                      onChangeFilteredDataHandler: _ctx.changeFilteredDataHandler,
                      onUpdatePages: _ctx.handlePageCount,
                      perPages: _ctx.stylesKpiData.styles,
                      loadingGrid: _ctx.loadingGrid,
                      onEditStyleId: _ctx.setEditStyleId,
                      onDuplicateEditId: _ctx.setDuplicateEditId
                    }, null, 8, ["stylesData", "totalStylesCount", "onChangeDataHandler", "onChangeFilteredDataHandler", "onUpdatePages", "perPages", "loadingGrid", "onEditStyleId", "onDuplicateEditId"])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_DialogBox, {
                key: 2,
                jsondata: _ctx.jsondata,
                importType: 1,
                title: _ctx.Title
              }, null, 8, ["jsondata", "title"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}